// extracted by mini-css-extract-plugin
export default {"content":"Contacts_content__wOySB","contacts":"Contacts_contacts__5EtpV","phone":"Contacts_phone__ULCsw","messagers":"Contacts_messagers__qoKzl"};